import React from 'react'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../../../features/components/Form/FieldLabelWrapper'
import SpreadSheet from '../../../../../../components/SpreadSheet'

import { AUDIENCE_SEGMENTS } from '../../../fields'
import useCommonStyles from '../../../../../../styles/common/listPage'

import useTableStyles from '../tableStyles'

const spreadSheetColumnLabels = ['Name', 'Size']

const AudienceSegmentsRow = ({ formik }) => {
  const commonClasses = useCommonStyles()
  const tableClasses = useTableStyles()
  const { values, setFieldValue } = formik

  const { t } = useTranslation()

  return (
    <div className={commonClasses.formRow}>
      <FieldLabelWrapper label={t('Audience segments')} labelFor={AUDIENCE_SEGMENTS}>
        <SpreadSheet
          name={AUDIENCE_SEGMENTS}
          setFieldValue={setFieldValue}
          formikData={values[AUDIENCE_SEGMENTS]}
          columnLabels={spreadSheetColumnLabels}
          maxRows={500}
          tableClassName={tableClasses.spreadSheetTable}
        />
      </FieldLabelWrapper>
    </div>
  )
}

export default AudienceSegmentsRow
